import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import ControlledTextInput from "components/FormInputs/ControlledTextInput";
import { setAuth } from "store/auth";
import { usePostLoginMutation } from "services/auth";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { LoginSchema } from "./_model";

// constants, initials
const initialFormState = {
  email: "",
  password: "",
};

function Basic() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues: initialFormState,
  });

  const [postCredentials, { isLoading }] = usePostLoginMutation();

  useEffect(() => {
    localStorage.clear();
  }, []);

  const submit = async (data) => {
    postCredentials(data)
      .then((res) => {
        if (res.data?.status == "success") {
          let response = res.data.response;
          let jwt = response.token;
          let uId = response.id;
          let isBDM = Number(response.is_bdm) == 1;

          let userData = {
            isLoggedIn: true,
            firstName: response.first_name,
            lastName: response.last_name,
            userId: uId,
            email: response.email,
            tokenKey: jwt,
            isBDM: isBDM,
          };
          localStorage.setItem("jwt", jwt);
          localStorage.setItem("uId", uId);
          dispatch(setAuth(userData));

          if (isBDM) {
            history.push("/user/orders");
          } else {
            history.push("/user/inventory");
          }
          Notify.success("Succefully Logged In!");
        } else if (res.error) {
          if (res.error?.status == 400) {
            Notify.failure(res.error.data.message);
          } else {
            Notify.failure(res.error.data.message);
          }
        } else {
          Notify.failure("Something went wrong!");
          // console.log(res);
        }
      })
      .catch((err) => {
        Notify.failure("Something went wrong!");
        console.log(err);
      });
  };

  return (
    <BasicLayout sx={{ backgroundColor: "#f0f2f5" }}>
      <Card sx={{ maxWidth: "400px", margin: "0 auto" }}>
        <CardHeader
          title={
            <MDTypography color="dark" sx={{ textAlign: "center" }}>
              Login
            </MDTypography>
          }
        />
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form">
            <MDBox mb={2}>
              <ControlledTextInput
                name="email"
                spellCheck={false}
                control={control}
                labelText="Email *"
                formControlProps={{
                  fullWidth: true,
                  variant: "outlined",
                  size: "small",
                }}
                inputProps={{
                  type: "email",
                }}
                autoComplete="email"
              />
            </MDBox>
            <MDBox mb={2}>
              <ControlledTextInput
                name="password"
                spellCheck={false}
                control={control}
                labelText="Password *"
                formControlProps={{
                  fullWidth: true,
                  variant: "outlined",
                  size: "small",
                }}
                inputProps={{
                  type: "password",
                }}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="primary"
                disabled={isLoading}
                sx={{ backgroundColor: "linear-gradient(195deg, #c93939, #9F0303)" }}
                onClick={handleSubmit(submit)}
                fullWidth
              >
                Login{" "}
                {isLoading && (
                  <CircularProgress
                    sx={{ width: "20px!important", height: "20px!important", ml: 1 }}
                    color="inherit"
                  />
                )}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
